/**
 * Atelier Royal: announcement-bar.js: <ar-announcements>.
 * Extra messages are a swipeable scroll-snap row (no autoplay, PLAN §6.5 rule 5).
 * Adds previous/next buttons for pointer and keyboard users (≥ 750px) and keeps the
 * decorative position dots in sync.
 */
class ARAnnouncements extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ar-announcement-track]');
    if (!this.track || this.dataset.arReady) return;
    this.dataset.arReady = 'true';
    this.items = [...this.track.children];
    this.dots = [...this.querySelectorAll('[data-ar-announcement-dot]')];

    this.querySelectorAll('[data-ar-announcement-step]').forEach((button) => {
      button.addEventListener('click', () => this.go(this.index() + Number(button.dataset.arAnnouncementStep)));
    });

    let frame = 0;
    this.track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.syncDots());
      },
      { passive: true }
    );
    this.syncDots();
  }

  index() {
    const width = this.track.clientWidth || 1;
    return Math.round(this.track.scrollLeft / width);
  }

  go(target) {
    const count = this.items.length;
    const index = ((target % count) + count) % count;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: index * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }

  syncDots() {
    const current = this.index();
    this.dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === current));
  }
}

if (!customElements.get('ar-announcements')) customElements.define('ar-announcements', ARAnnouncements);
